import appLoader from "./appLoader"

export const AppLoader = appLoader;